import { withStyles } from '@mui/styles';
import { connect } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';
import { Modal, Fade } from '@mui/material';

// Context
import { withTranslate } from '../../../core/TenantProvider';
// Components, Atoms, Molecules, Organisms
import APHeading from '../../atoms/APHeading';
import APButton from '../../atoms/APButton';
// Files in the same folder
import APConfirmationModalStyles from './styles/APConfirmationModal.style';
// Redux
import { actions as SessionActions } from '../../../redux/modules/session';

type ConfimationModalType = 'deleteBankDetails';

interface APConfirmationModalProps {
    open: boolean;
    handleConfirm: Function;
    handleCancel: Function;
    type: ConfimationModalType;
    translate: Function;
    classes: any;
}

interface ConfirmationModalConfig {
    heading: string;
    subHeading: string;
    cancelButton: string;
    confirmButton: string;
}

const CONFIRMATION_MODAL_CONFIGS: Record<ConfimationModalType, ConfirmationModalConfig> = {
    deleteBankDetails: {
        heading: 'settings.bankDetails.confirmationModal.confirmationTextHeading',
        subHeading: 'settings.bankDetails.confirmationModal.confirmationTextSubHeading',
        cancelButton: 'settings.bankDetails.confirmationModal.cancelButtonText',
        confirmButton: 'settings.bankDetails.confirmationModal.removeButtonText',
    },
};

const APConfirmationModal = (props: APConfirmationModalProps) => {
    const {
        open,
        handleConfirm,
        handleCancel,
        type,
        translate,
        classes } = props;

    const config: ConfirmationModalConfig = CONFIRMATION_MODAL_CONFIGS[type];

    return (
        <Modal
            aria-labelledby="Confirmation modal"
            aria-describedby="Confirmation modal"
            className={classes.modal}
            open={open}
            closeAfterTransition
        >
            <Fade in={open}>
                <div className={classes.paper}>
                    <div className={classes.panel}>
                        <APHeading className={classes.modalHeader} variant="h3">
                            {translate(config.heading)}
                        </APHeading>
                        <p>{translate(config.subHeading)}</p>
                        <div className={classes.buttonSection}>
                            <APButton
                                className={classes.cancelButton}
                                onClick={() => handleCancel()}
                                variant="contained"
                            >
                                {translate(config.cancelButton)}
                            </APButton>
                            <APButton
                                className={classes.confirmButton}
                                variant="contained"
                                color="primary"
                                onClick={() => handleConfirm()}
                            >
                                {translate(config.confirmButton)}
                            </APButton>
                        </div>
                    </div>
                </div>
            </Fade>
        </Modal>
    );
}

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
    clearSession: SessionActions.clearSession
}, dispatch);


export default (
    withTranslate(
        withStyles(APConfirmationModalStyles)(
            connect(null, mapDispatchToProps)(APConfirmationModal)
        )
    )
);